import React from 'react';
import { ProgressBar } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import './VerificationStatusCheck.css';
import { IconS24Close24 } from '@is24/cosma-ui-icons';
import { useTvsState } from '../../utils/useTvsState';
import { VerificationMethod } from '../../@types/VerificationMethod';

interface VerificationStatusCheckProps {
  progress: number;
  verificationMethod?: VerificationMethod;
  showCloseButton?: boolean;
  onClose?: () => void;
}

const VerificationStatusCheck: React.FC<VerificationStatusCheckProps> = ({
  progress,
  verificationMethod,
  showCloseButton = false,
  onClose,
}) => {
  const { t } = useTranslation();
  const [, setTvsState] = useTvsState();

  const getProgressMessage = () => {
    if (verificationMethod === VerificationMethod.Finapi) {
      return t('VerificationProgressMessage.finapi.message');
    }
    return showCloseButton
      ? t('VerificationProgressMessage.veriff.message.98')
      : t('VerificationProgressMessage.veriff.message.0');
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setTvsState('');
    }
  };

  return (
    <div aria-modal='true' className='modal-backdrop' style={{ zIndex: 2000 }}>
      <div className='modal-container checker-modal-container' style={{ height: 600, width: 500 }}>
        <div className='modal-title-wrapper'>
          <h4 className='modal-headline'>{t('VerificationLandingPage.heading')}</h4>
          {showCloseButton && <IconS24Close24 onClick={handleClose} data-testid='modal-close-icon' />}
        </div>
        <div className='modal-content-wrapper'>
          <div className='modal-content'>
            <div className='verification-check-content padding-horizontal-xxl' data-testid='spinnerOverlay'>
              <ProgressBar type='circular' progress={progress} showLabel size='small' />
              <p className='verification-check-text padding-horizontal-xxl'>{getProgressMessage()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatusCheck;
